// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__p2Pvs","code":"styles_code__E37dl","bottomInfo":"styles_bottomInfo__+LHA1","infoMessage":"styles_infoMessage__NKSyP","loading":"styles_loading__I4X7a"};